import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0e1c200"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-map-ctn flex-column resource-detail-ctn" }
const _hoisted_2 = { class: "ml_div" }
const _hoisted_3 = { class: "map-ctn" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "div1" }
const _hoisted_7 = {
  class: "topic",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_8 = { class: "b_n" }
const _hoisted_9 = { class: "liu_lan_liang" }
const _hoisted_10 = { class: "type" }
const _hoisted_11 = { style: {"display":"none !important","justify-content":"flex-end","align-items":"flex-start"} }
const _hoisted_12 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 我来运营 ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "空间现状信息", -1))
const _hoisted_17 = { class: "space_status" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "用地权属主体", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "用地面积", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "租售意向", -1))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "建筑面积", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "现状照片", -1))
const _hoisted_27 = {
  key: 0,
  class: "now_img"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "经营出让条件", -1))
const _hoisted_31 = {
  key: 0,
  class: "jy_tj"
}
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 1,
  class: "jy_tj",
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "地块详情", -1))
const _hoisted_35 = {
  key: 0,
  class: "file_list"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 1,
  class: "file_list",
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "附件", -1))
const _hoisted_40 = {
  key: 0,
  class: "file_list"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "file_list",
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_43 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-div" }, [
  /*#__PURE__*/_createElementVNode("span", null, "快速咨询"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_45 = { class: "button-div" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-div" }, [
  /*#__PURE__*/_createElementVNode("span", null, "我来运营"),
  /*#__PURE__*/_createElementVNode("span", null, "(快速申请)")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_48 = [
  _hoisted_47
]

import wx from "weixin-js-sdk"
import { onMounted, ref, watch, onBeforeUnmount, onBeforeMount, onActivated } from "vue"
import { showImagePreview } from "vant"
import MapMain from "@/layout/mapMain/index.vue"
import Cities from "@/components/CitiesAll.vue"
import config from "@/modules/appConfig"
import debounce from "lodash-es/debounce"
import { getModules } from "@/modules/arcgisAPI"
import { useMapStore } from "@/store/modules/map"
import { queryTask, changeExtent, charCount, polyonOffset } from "@/utils/commons"
import { getUserDetailAPi, dicAPi, getTokenAPi } from "@/api/login"
import { addFeedBackApi } from "@/api/home"
import { getResourceMap } from "@/api/resource"
import {
  showLoadingToast,
  showSuccessToast,
  showFailToast,
  showNotify,
  closeToast,
  showConfirmDialog,
  Collapse,
  CollapseItem
} from "vant"
import { getNoLoginCityCodeHome } from "@/utils/cookies"
import router from "@/router"
import { useRoute } from "vue-router"
import { isArray } from "lodash-es"
import appConfig from "@/modules/appConfig"
import { authoritiesApi } from "@/api/user" // 获取用户权限
import { getDetailApi, applyApi, checkOffResourceShelfApi } from "@/api/resource"
import { collectApi, removeCollectApi } from "@/api/projectDemand"
import { setToken, getTokenIn } from "@/utils/cookies"
import commons from "@/utils/commons"
import DataList from "@/api/common"

export default /*#__PURE__*/_defineComponent({
  __name: 'mapNew',
  setup(__props) {

const route = useRoute()
const mapStore = useMapStore()
const areaRef = ref()
const searchValue = ref("")
const city = ref(getNoLoginCityCodeHome() || "")
const type = ref("")
let layer: any = null
let watchEvent: any = null
let clickEvent: any = null
let pointLayer: any = null
let sourceLayer: any = null
let staticLayer: any = null
let lineLayer: any = null
const option2: any = ref([])
let pointList: any = []
let cityStatic: any = []
let regionStatic: any = []
const searchTpye = ref("")
let landLayer: any = null
// let graphicLine: any = null
let selectGeometry: any = null
// 资源详情参数********************************************************************
const anchors = ref([40, Math.round(0.4 * window.innerHeight), Math.round(0.8 * window.innerHeight)])
const height: any = ref([Math.round(0.4 * window.innerHeight)])
const contentDraggable = ref(false)
const resourceId: any = ref() //资源id
const onShelf = ref(true) //资源是否上架
const activeName = ref(["1", "2", "3", "4"])
const shareDialog = ref(false) //分享弹框
const accountList = ref([]) //账户类型
const userDetail = ref() //用户基本信息
const dialogShow = ref<boolean>(false) //控制资源详情弹框显示隐藏
const datas: any = ref({
  xj: ""
})
const scShow = ref(true) //收藏按钮权限控制
const applayShow = ref(true) //我要申请按钮权限控制
// 资源详情参数******************************************************************************
onActivated(() => {
  city.value = getNoLoginCityCodeHome() || ""
  config.changeView(config.mapView)
})
onMounted(() => {
  getAllDict() //获取字典
})
// 从首页进进行重载，回退的话，不刷新
router.beforeEach((to: any, form: any) => {
  if (to.path === "/resource/map" && form.path === "/home") {
    initData()
  }
})
// 获取字典
const getAllDict = async () => {
  const res: any = await dicAPi("resource_type")
  if (res.code == 200) {
    option2.value = []
    res.data.map((item: any) => {
      let object = {
        text: item.name,
        value: item.code
      }
      option2.value.push(object)
    })
  }

  const res2: any = await dicAPi("account_type")
  if (res2.code == 200) {
    accountList.value = res.data
  }
}
const onSearch = debounce(() => {
  getData()
}, 500) // 防抖时间为500毫秒
const onClear = () => {
  // 重新搜索
  getData()
}

const change = () => {
  getData()
}
const resetData = async () => {
  pointList = []
  if (sourceLayer) {
    sourceLayer.visible = false
  }
  config.activeView.graphics.removeAll()
  const [GraphicsLayer] = await getModules(["esri/layers/GraphicsLayer"])
  if (!lineLayer) {
    lineLayer = new GraphicsLayer()
    config.activeView.map.add(lineLayer)
  } else {
    lineLayer.removeAll()
  }
  if (!pointLayer) {
    pointLayer = new GraphicsLayer({
      visible: false
    })
    config.activeView.map.add(pointLayer)
  } else {
    pointLayer.removeAll()
  }
  if (!staticLayer) {
    staticLayer = new GraphicsLayer({
      visible: false
    })
    config.activeView.map.add(staticLayer)
  } else {
    staticLayer.removeAll()
  }
  if (!landLayer) {
    landLayer = new GraphicsLayer()
    config.activeView.map.add(landLayer)
  } else {
    landLayer.removeAll()
  }
}
// 获取查询数据
const getData = async () => {
  resetData()
  const params: any = {
    zymc: searchValue.value,
    lx: type.value,
    curent: 1,
    size: 20000
  }

  const data = mapStore.xzqhbm
  const code = data.code
  params.xzqhbm = code

  showLoadingToast({
    message: "查询中",
    duration: 0
  })
  getResourceMap(params)
    .then(async (res: any) => {
      if (res && res.sucess) {
        showSuccessToast({
          message: "已查到相关数据",
          duration: 2000
        })
        const records = res.data.records
        if (records.length > 0) {
          const [Polygon, Graphic] = await getModules(["esri/geometry/Polygon", "esri/Graphic"])
          records.forEach(async (ele: any) => {
            const geojson = ele.geom || ele.geojson
            if (geojson && geojson != null) {
              const geojsonG = JSON.parse(geojson)
              const polygon = new Polygon({
                rings: geojsonG.coordinates,
                spatialReference: config.activeView.spatialReference
              })

              pointList.push(
                new Graphic({
                  geometry: polygon.centroid,
                  attributes: {
                    ObjectID: ele.sfid,
                    id: ele.sfid,
                    zymc: ele.zymc,
                    type: "地块"
                  }
                })
              )
              const fillSymbol = {
                type: "simple-fill",
                color: [227, 139, 79, 0.2],
                outline: {
                  color: [0, 255, 255, 1],
                  width: 2
                }
              }
              const graphic = new Graphic({
                geometry: polygon,
                symbol: fillSymbol,
                attributes: { ...ele, type: "地块", geometry: polygon }
              })
              const strCount = charCount(ele.zymc)
              let fieldName = ele.zymc
              if (strCount > 20) {
                fieldName = ele.zymc.slice(20) + "···"
              }
              const widthLength = 17 * (strCount > 20 ? 21 : strCount)
              const imageUrl = await createImage(fieldName, widthLength, 33)
              const graphicText = new Graphic({
                geometry: polygon.centroid,
                symbol: {
                  type: "picture-marker",
                  width: widthLength + "px",
                  height: "53px",
                  url: imageUrl,
                  outline: {
                    color: [255, 255, 255],
                    width: 0
                  },
                  yoffset: 18
                },
                attributes: { ...ele, type: "地块", geometry: polygon }
              })
              pointLayer.add(graphic)
              pointLayer.add(graphicText)
            }
          })
          if (searchTpye.value === "全国") {
            showSourceLayer()
          } else {
            initStatics(records)
          }
        } else {
          showFailToast({
            message: "未找到相关数据",
            duration: 2000
          })
        }
      }
    })
    .finally(() => {
      // closeToast()
    })
}
const initStatics = async (records: any) => {
  if (!config.activeView) return
  cityStatic = []
  regionStatic = []

  // 区级服务
  const url = (window as any).xzqh + "/4"
  const xzqhField = (window as any).shiField

  const data = mapStore.xzqhbm
  let code = data.code.slice(0, 4)
  const where: any = []
  where.push(`${xzqhField} = ${code + "00"}`)
  const params = {
    where: where.join(" and "),
    outFields: ["*"],
    returnGeometry: true
  }
  const res: any = await queryTask(url, params)
  const resCity: any = await queryTask((window as any).xzqh + "/5", {
    where: `${xzqhField} = ${code + "00"}`,
    outFields: ["*"],
    returnGeometry: true
  })
  const [Graphic] = await getModules(["esri/Graphic"])
  // 统计市级的数量
  if (resCity && resCity.length) {
    const geometry = resCity[0].geometry
    selectGeometry = geometry
    const count = records.length
    const imageUrl = await createImage([resCity[0].attributes["市名"], count + "个"], 90, 50)
    const graphicText = new Graphic({
      geometry: geometry.centroid,
      symbol: {
        type: "picture-marker",
        width: "90px",
        height: "50px",
        url: imageUrl,
        outline: {
          color: [255, 255, 255],
          width: 0
        }
      },
      attributes: {
        type: "城市",
        geometry,
        count
      },
      visible: false
    })
    cityStatic.push(graphicText)
  }
  // 统计区县的数量
  if (res && res.length) {
    let newRecords: any = {}
    records.forEach((item: any) => {
      if (newRecords[item.xzqhbm]) {
        newRecords[item.xzqhbm] += 1
      } else {
        newRecords[item.xzqhbm] = 1
      }
    })

    res.forEach(async (ele: any) => {
      let count = 0
      if (ele.attributes["县代码"] in newRecords) {
        count = newRecords[ele.attributes["县代码"]]
      }
      const widthLength = 25 * charCount(ele.attributes["县名"])
      const imageUrl = await createImage([ele.attributes["县名"], count + "个"], widthLength, 50)
      const graphicText1 = new Graphic({
        geometry: ele.geometry.centroid,
        symbol: {
          type: "picture-marker",
          width: widthLength + "px",
          height: "50px",
          url: imageUrl,
          outline: {
            color: [255, 255, 255],
            width: 0
          }
        },
        attributes: {
          type: "区县",
          geometry: ele.geometry,
          count,
          name: ele.attributes["县名"],
          code: ele.attributes["县代码"]
        },
        visible: false
      })
      regionStatic.push(graphicText1)
    })
    Promise.resolve().then(() => {
      staticLayer.visible = true
      staticLayer.addMany(cityStatic)
      staticLayer.addMany(regionStatic)
      if (searchTpye.value === "城市") {
        cityStatic.forEach((city: any) => {
          city.visible = true
        })
      } else {
        regionStatic.forEach((region: any) => {
          region.visible = true
        })
        const item = regionStatic.filter((ele: any) => {
          if (ele.attributes.code === data.code) {
            selectGeometry = ele.attributes.geometry
            return true
          }
        })
        drawArea(item[0])
      }
      drawLine()
    })
  }
}

const showSourceLayer = async () => {
  if (!sourceLayer) {
    const [FeatureLayer] = await getModules(["esri/layers/FeatureLayer"])
    sourceLayer = new FeatureLayer({
      id: "sourceLayer",
      objectIdField: "ObjectID",
      outFields: ["*"],
      fields: [
        { name: "id", type: "string" },
        { name: "zymc", type: "string" }
      ],
      geometryType: "point",
      source: pointList,
      // url,
      renderer: {
        type: "simple",
        // symbol: {
        //   type: "simple-marker",
        //   size: 15,
        //   color: "rgba(255, 205, 1, 0.85)",
        //   outline: {
        //     color: "rgba(255, 205, 1, 0.5)",
        //     width: 8
        //   }
        // }

        symbol: {
          type: "picture-marker",
          url: "/static/images/cluster-point.png",
          width: "21px",
          height: "30px"
        }
      },
      featureReduction: {
        type: "cluster",
        clusterRadius: "40px",
        clusterMinSize: "40px",
        clusterMaxSize: "40px",
        // symbol: {
        //   type: "simple-marker",
        //   style: "circle",
        //   color: "rgba(0, 116, 112, 0.7)",
        //   outline: {
        //     color: "rgba(0, 116, 112, 0.3)",
        //     width: 5
        //   }
        // },
        labelingInfo: [
          {
            deconflictionStrategy: "none",
            labelExpressionInfo: {
              expression: "$feature.cluster_count"
            },
            symbol: {
              type: "text",
              color: "#cba407",
              font: {
                weight: "bold",
                family: "Noto Sans",
                size: "14px"
              },
              yoffset: 5
            },
            labelPlacement: "center-center"
          }
        ]
      },
      visible: true
    })
    config.activeView.map.add(sourceLayer)
  } else {
    sourceLayer.visible = true
    sourceLayer.refresh()
  }
}

const initMapEvent = () => {
  if (!mapStore.loading2dFinish) return
  if (!watchEvent) {
    watchEvent = config.activeView.watch("scale", (scaleValue: any) => {
      // 当放大到一定程度，展示资源地图
      if (searchTpye.value === "全国") {
        if (sourceLayer && pointLayer) {
          if (scaleValue >= 20000) {
            sourceLayer.visible = true
            pointLayer.visible = false
            landLayer.visible = false
          } else {
            sourceLayer.visible = false
            pointLayer.visible = true
            landLayer.visible = true
          }
        }
      } else {
        if (pointLayer) {
          if (scaleValue >= 1180000) {
            cityStatic.forEach((city: any) => {
              city.visible = true
            })
            regionStatic.forEach((region: any) => {
              region.visible = false
            })
            staticLayer.visible = true
            pointLayer.visible = false
            landLayer.visible = false
          } else if (scaleValue >= 150000) {
            cityStatic.forEach((city: any) => {
              city.visible = false
            })
            regionStatic.forEach((region: any) => {
              region.visible = true
            })
            staticLayer.visible = true
            pointLayer.visible = false
            landLayer.visible = false
          } else {
            staticLayer.visible = false
            pointLayer.visible = true
            landLayer.visible = true
          }
        }
      }
    })
  }
  if (!clickEvent) {
    clickEvent = config.activeView.on("click", (event: any) => {
      config.activeView.hitTest(event).then(async (response: any) => {
        dialogShow.value = false
        clearLand()
        if (response && response.results.length) {
          for (var i = 0; i < response.results.length; i++) {
            const graphic = response.results[i]
            if (graphic.graphic.attributes) {
              const ids = graphic.graphic.attributes.sfid
              var datas = {
                originalSfid: ids,
                type: "resource"
              }
              addFeedBackApi(datas).then(() => {})

              const { type, geometry, name } = graphic.graphic.attributes
              if (type === "城市") {
                if (geometry) {
                  config.activeView.extent = changeExtent(geometry.extent.clone())
                }
                cityStatic.forEach((city: any) => {
                  city.visible = false
                })
                regionStatic.forEach((region: any) => {
                  region.visible = true
                })
                staticLayer.addMany(regionStatic)
                drawLine()
              } else if (type === "区县") {
                const item = regionStatic.filter((ele: any) => {
                  if (ele.attributes && ele.attributes.name === name) {
                    selectGeometry = ele.attributes.geometry
                    return true
                  }
                })
                await drawArea(item[0])
                drawLine()
              } else if (type === "地块") {
                dealLand(graphic.graphic.attributes)
                const ids = graphic.graphic.attributes.sfid
                // ***************************
                //打开弹框lml
                // router.push({ path: "/resource/detail", query: { id: ids } })
                //  ***********************
                resourceId.value = ids
                if (getTokenIn()) {
                  getUserDetailAPi().then((res: any) => {
                    if (res.code == 200) {
                      userDetail.value = res.data
                    } else {
                      showNotify({ type: "danger", message: res.message })
                    }
                  })
                }
                // 需要登录
                if (route.query.loginCode) {
                  // 根据登录账号获取token
                  getTokens(route.query.loginCode)
                  // 缓存openid备用
                  if (route.query.openId) {
                    localStorage.setItem("openId", route.query.openId)
                  }
                }
                getDtail(ids)
                height.value = Math.round(0.4 * window.innerHeight)
                dialogShow.value = true
              }
            }
          }
        }
      })
    })
  }
}

const drawArea = async (item: any) => {
  regionStatic = regionStatic.filter((ele: any) => {
    return ele.name !== "area-active"
  })
  const delList: any[] = []
  const graphicsLength = staticLayer.graphics.length
  for (let i = graphicsLength - 1; i >= 0; i--) {
    const ele = staticLayer.graphics.getItemAt(i)
    if (ele && ele.name === "area-active") {
      delList.push(ele)
    }
  }
  staticLayer.removeMany(delList)

  const { name, count, geometry } = item.attributes
  const widthLength = 25 * charCount(name)
  const imageUrl = await createImage([name, count + "个"], widthLength, 50, "rgb(247, 49, 49)")
  const [Graphic] = await getModules(["esri/Graphic"])
  const graphicText = new Graphic({
    name: "area-active",
    geometry: geometry.centroid,
    symbol: {
      type: "picture-marker",
      width: widthLength + "px",
      height: "50px",
      url: imageUrl,
      outline: {
        color: [255, 255, 255],
        width: 0
      }
    }
  })
  regionStatic.push(graphicText)
  staticLayer.add(graphicText)
}

// 画边界线
const drawLine = async () => {
  if (lineLayer) {
    lineLayer.removeAll()
  }

  const symbol = {
    type: "simple-fill",
    color: [255, 205, 1, 0.15],
    outline: {
      color: [255, 205, 1],
      width: 1
    }
  }
  const [Graphic] = await getModules(["esri/Graphic"])
  const graphicLine = new Graphic({ symbol, geometry: selectGeometry })
  lineLayer.add(graphicLine)
  if (selectGeometry) {
    config.activeView.extent = changeExtent(selectGeometry.extent.clone())
  }
}

// 清除选中的地块样式
const clearLand = () => {
  const delList: any = []
  landLayer.graphics.forEach((item: any) => {
    if (item.name === "select-land") {
      delList.push(item)
    }
    if (item.name === "text-land") {
      delList.push(item)
    }
  })
  landLayer.removeMany(delList)
}
// 画选中地块
const dealLand = async (info: any) => {
  const { geometry, zymc } = info
  clearLand()

  const fillSymbol = {
    type: "simple-fill",
    color: [247, 49, 49, 0.3],
    outline: {
      color: [247, 49, 49, 1],
      width: 2
    }
  }
  const [Graphic] = await getModules(["esri/Graphic"])
  const selectland = new Graphic({
    geometry,
    symbol: fillSymbol,
    name: "select-land"
  })

  const widthLength = 17 * charCount(zymc)
  const imageUrl = await createImage(zymc, widthLength, 33, "rgb(247, 49, 49)")
  const graphicText = new Graphic({
    name: "text-land",
    geometry: geometry.centroid,
    symbol: {
      type: "picture-marker",
      width: widthLength + "px",
      height: "53px",
      url: imageUrl,
      outline: {
        color: [255, 255, 255],
        width: 0
      },
      yoffset: 18
    }
  })
  landLayer.add(selectland)
  landLayer.add(graphicText)

  // 定位到图形时添加偏移
  config.activeView.extent = changeExtent(geometry.extent.clone())
  const screenPoint = config.activeView.toScreen(geometry.centroid)
  screenPoint.y += 120 // 向上偏移200像素
  const mapPoint = config.activeView.toMap(screenPoint)
  config.activeView.goTo({
    target: mapPoint,
    scale: 2500
  })
}

/**
 * 生成带文字的图片
 */
const drawRoundRect = (ctx: any, x: number, y: number, width: number, height: number, radius: number) => {
  ctx.beginPath()
  ctx.moveTo(x + radius, y)
  ctx.lineTo(x + width - radius, y)
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
  ctx.lineTo(x + width, y + height - radius)
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
  ctx.lineTo(x + radius, y + height)
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
  ctx.lineTo(x, y + radius)
  ctx.quadraticCurveTo(x, y, x + radius, y)
  ctx.closePath()
}

const createImage = (text: any, width = 100, height = 33, color = "#ffcd01") => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas")
    canvas.width = width
    canvas.height = height
    const ctx: any = canvas.getContext("2d")
    ctx.font = "bold 15px Arial"

    ctx.fillStyle = color
    drawRoundRect(ctx, 0, 0, width, height, 10)
    ctx.fill()
    ctx.textAlign = "center"
    ctx.textBaseline = "middle"
    ctx.fillStyle = "#fff"
    if (isArray(text)) {
      text.forEach((item: any, index: number) => {
        ctx.fillText(item, canvas.width / 2, index === 0 ? 16 : 36)
      })
      resolve(canvas.toDataURL("image/png"))
    } else {
      ctx.fillText(text, canvas.width / 2, canvas.height / 2)

      const newHeight = canvas.height + 30
      const tempCanvas = document.createElement("canvas")
      tempCanvas.width = canvas.width
      tempCanvas.height = newHeight
      const tempCtx: any = tempCanvas.getContext("2d")

      tempCtx.drawImage(canvas, 0, 0)
      tempCtx.fillStyle = color
      tempCtx.strokeStyle = color
      tempCtx.lineWidth = 2
      tempCtx.beginPath()
      tempCtx.moveTo(canvas.width / 2, newHeight)
      tempCtx.lineTo(canvas.width / 2 + 1, height)
      tempCtx.lineTo(canvas.width / 2 - 1, height)
      tempCtx.closePath()
      tempCtx.fill()
      tempCtx.stroke()
      resolve(tempCanvas.toDataURL("image/png"))
    }
  })
}

watch(
  () => mapStore.loading2dFinish,
  (value) => {
    if (value) {
      initMapEvent()
      initData()
    }
  }
)

watch(
  () => mapStore.xzqhbm,
  (value) => {
    if (value) {
      initData()
    }
  }
)

const initData = () => {
  const data = mapStore.xzqhbm
  searchTpye.value = "全国"
  if (mapStore.loading2dFinish) {
    if (data.searchTpye === "城市") {
      searchTpye.value = "城市"
    } else if (data.searchTpye === "区县") {
      searchTpye.value = "区县"
    }
    getData()
  }
}

// onBeforeUnmount(() => {
// if (layer) {
//   config.activeView.map.remove(layer)
//   layer = null
// }
// if (clickEvent) {
//   clickEvent.remove()
//   clickEvent = null
// }
// if (clickEvent) {
//   clickEvent.remove()
//   clickEvent = null
// }
// })

const onChange = () => {
  const newCode = city.value.indexOf(",")
  const code = newCode > 0 ? city.value.substring(0, newCode) : city.value
  sessionStorage.setItem("noLogincityCodeHome", code)
}
// 资源详情事件start*****************************************************************
// const aa = () => {
//   resourceId.value = "1840589360326074370"
//   getDtail(resourceId.value)
//   height.value = Math.round(0.4 * window.innerHeight)
//   dialogShow.value = true
// }
const setHeight = () => {
  if (height.value <= 40) {
    return 0
  }
  return height.value - 115
}
const previousScrollTop = ref(0)
const onScroll = (e: any) => {
  const scrollTop = e.target.scrollTop
  if (scrollTop > previousScrollTop.value) {
    // 向下滚动
    console.log("向下滚动")
    contentDraggable.value = true
    // 弹框高度设置最高
    height.value = Math.round(0.8 * window.innerHeight)
  } else {
    // 向上滚动
    // if (height.value >= 820) {
    //   // 禁止面板内容滚动折叠面板
    //   contentDraggable.value = false
    // }
    // 回滚到最上面则弹框高度设置最低
    setTimeout(() => {
      if (scrollTop == 0) {
        height.value == Math.round(0.8 * window.innerHeight) ? (height.value = 440) : 40
      }
    }, 100)
    console.log("向上滚动#####")
    if (startY.value <= 300) {
      contentDraggable.value = true
    } else {
      contentDraggable.value = false
    }
  }
  previousScrollTop.value = scrollTop
}
// 滚动开始的位置
const startY = ref(0)
const ontouchstart = (e: any) => {
  startY.value = e.touches[0].clientY
  console.log(startY.value)
}
// 页面关闭传递消息
onBeforeUnmount(() => {
  wx.miniProgram.postMessage({ data: "offResource" })
})
onBeforeMount(() => {
  // 分享打开资源详情页面
  if (route.query?.fromFlag == "isShare") {
    checkOffShelf(resourceId.value)
  } else {
    onShelf.value = true
  }
})
// 判断资源是否已下架
const checkOffShelf = async (id: any) => {
  checkOffResourceShelfApi(id).then((res: any) => {
    if (res.code == 200) {
      if (res.data) {
        // 抱歉，此资源已被删除/下架
        onShelf.value = false
      }
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取token
const getTokens = async (datas: any) => {
  showLoadingToast({
    message: "登录中..."
  })
  getTokenAPi(datas, commons.setT026()).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      setToken(res.data)
      localStorage.setItem("token-key", res.data)
      getDtail(resourceId.value)
      showNotify({ type: "success", message: "登录成功" })
      router.replace({ path: "/resource/detail", query: { id: resourceId.value } })
    } else {
      getDtail(resourceId.value)
      router.replace({ path: "/resource/detail", query: { id: resourceId.value } })
    }
  })
}
// 获取图片预览地址
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}
// 现状照片点击预览
const openImagePreview = (images: any, index: number) => {
  console.log(images)
  var imgs: any = []
  images.map((element: any) => {
    imgs.push(DataList.UpdtImagePrefix() + element.sfid)
  })
  showImagePreview({
    images: imgs,
    showIndex: true,
    loop: false,
    closeable: true,
    startPosition: index
  })
}
// 获取详情
const getDtail = async (id: any) => {
  if (id) {
    showLoadingToast({
      message: "加载中"
    })
    getDetailApi(id).then((res: any) => {
      if (res.code == 200) {
        closeToast()
        datas.value = res.data
        if (getTokenIn()) {
          getUserDetailAPi().then((res: any) => {
            if (res.code == 200) {
              userDetail.value = res.data
            } else {
              showNotify({ type: "danger", message: res.message })
            }
          })
        }
        const geojson = res.data.geom || res.data.geojson
        wx.miniProgram.postMessage({
          data: {
            isResource: true,
            title: datas.value.zymc,
            id: id,
            img: DataList.UpdtImagePrefix() + datas.value.fmtpDetail?.sfid
          }
        })
      } else {
        closeToast()
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
// 获取用户基本信息
const getUserDetail = (secuss: any) => {
  getUserDetailAPi().then((res: any) => {
    if (res.code == 200) {
      userDetail.value = res.data
      secuss()
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 我要申请
const onClickApply = () => {
  if (!getTokenIn()) {
    showConfirmDialog({
      // title: "标题",
      message: "当前服务需要登录并认证之后才可以正常使用! 去登录>>",
      confirmButtonText: "确认"
    }).then(() => {
      //未登录情况需要 跳转到个人中心首页
      router.push({ path: "/user", query: { from: "resource", resourceId: resourceId.value } })
    })
  } else {
    // 已经登录需要判断账号类型以及是否认证
    getUserDetail(isAuthentication())
  }
}
// 判断是否认证
const isAuthentication = () => {
  var flag = userDetail.value?.authenticationStatus //认证判断的字段
  console.log(flag)
  var type = userDetail.value?.accountType //账号类型
  var checkStatus = userDetail.value?.authenticationDetail?.status
  // 未认证要判断是否
  //   CHECKING("checking","待审核"),
  //  AGREE("agree","已通过"),
  //  DISAGREE("disagree","已驳回");
  if (flag == "uncheck") {
    showConfirmDialog({
      message: "当前服务需要进行认证之后才可以正常使用! 去认证>>",
      confirmButtonText: "确认"
    }).then(() => {
      // 待审核  驳回
      if (checkStatus == "checking" || checkStatus == "disagree") {
        if (type == "personnel") {
          router.push({ path: "/authenticationPerson", query: { flag: "hasDetail" } })
        } else if (type == "enterprise") {
          router.push({ path: "/authenticationCompany", query: { flag: "hasDetail" } })
        }
      } else {
        //未登录情况需要 跳转到个人中心首页
        if (type == "personnel") {
          router.push({ path: "/authenticationPerson" })
        } else if (type == "enterprise") {
          router.push({ path: "/authenticationCompany" })
        }
      }
    })
  } else if (flag == "checked") {
    // 已经认证情况
    var params = {
      resourceSfid: resourceId.value,
      // type: datas.value?.isApply == "1" ? "cancel" : "apply"
      type: "apply"
    }
    // showLoadingToast({
    //   message: "加载中"
    // })
    // 需要跳转到申请页面
    router.push({ path: "/applayForm", query: { id: route.query.id } })
    // applyApi(params).then((res: any) => {
    //   if (res.code == 200) {
    //     closeToast()
    //     // var text = datas.value?.isApply == "1" ? "取消成功" : "申请成功!请在申请记录中查看结果"
    //     var text = "申请成功!请在申请记录中查看结果"
    //     showNotify({ type: "success", message: text })
    //     getDtail(resourceId.value)
    //   } else {
    //     closeToast()
    //     showNotify({ type: "danger", message: res.message })
    //   }
    // })
  }
}
// 收藏与取消收藏
const onClickCollect = async () => {
  if (!getTokenIn()) {
    showConfirmDialog({
      message: "当前服务需要登录并认证之后才可以正常使用! 去登录>>",
      confirmButtonText: "确认"
    }).then(() => {
      //未登录情况需要 跳转到个人中心首页
      router.push({ path: "/user", query: { from: "resource", resourceId: resourceId.value } })
    })
  } else {
    // 已经登录进行接口调用
    var newDatasNo = resourceId.value
    var newDatasHas = {
      originalSfid: resourceId.value,
      type: "resource"
    }
    var params = datas.value.isCollect == "1" ? newDatasNo : newDatasHas
    getUserDetail(setCollect(params))
  }
}
const setCollect = async (params: any) => {
  showLoadingToast({
    message: "加载中"
  })
  var newUrl = datas.value.isCollect == "1" ? removeCollectApi : collectApi
  newUrl(params).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      closeToast()
      var text = datas.value?.isCollect == "1" ? "取消成功" : "收藏成功!请前往我的收藏查看"
      showNotify({ type: "success", message: text })
      getDtail(resourceId.value)
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 客服咨询跳转到壳子
const onService = async () => {
  if (!getTokenIn()) {
    showConfirmDialog({
      message: "当前服务需要登录之后才可以正常使用! 去登录>>",
      confirmButtonText: "确认"
    }).then(() => {
      //未登录情况需要 跳转到个人中心首页
      router.push({ path: "/user", query: { from: "resource", resourceId: resourceId.value } })
    })
  } else {
    // 已经登录
    wx.miniProgram.redirectTo({
      url: `/pages/webview/webview?kf=${resourceId.value}&kfTitle=${datas.value.zymc}&kfImg=${datas.value.fmtpDetail?.sfid}`
    })
  }
}
// 分享
const onShare = async () => {
  shareDialog.value = true
  wx.miniProgram.postMessage({
    data: {
      isResource: true,
      title: datas.value.zymc,
      fromFlag: "isShare",
      id: resourceId.value || datas.value.sfid,
      img: DataList.UpdtImagePrefix() + datas.value.fmtpDetail?.sfid
    }
  })
}
const offShareDialog = () => {
  shareDialog.value = false
}
watch(
  () => height,
  (newVal, oldVal) => {
    //回滚
    console.log(newVal.value)
    if (newVal.value == 40 || newVal.value == Math.round(0.4 * window.innerHeight)) {
      let container: any = document.querySelector(".dialog_content")
      if (container) {
        container.scrollTop = 0
      }
    }
  },
  {
    // deep: true
  }
)
// 资源详情事件end*****************************************************************

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_P = _resolveComponent("P")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_floating_panel = _resolveComponent("van-floating-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: searchValue.value,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
        _unref(onSearch)
      ],
      "show-action": "",
      placeholder: "请输入搜索关键词",
      onSearch: _unref(onSearch),
      onClear: onClear,
      onCancel: onClear
    }, {
      action: _withCtx(() => [
        _createElementVNode("div", {
          class: "",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSearch) && _unref(onSearch)(...args)))
        }, "搜索")
      ]),
      _: 1
    }, 8, ["modelValue", "onSearch", "onUpdate:modelValue"]),
    _createVNode(_component_van_dropdown_menu, { style: {"position":"relative"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Cities, {
            city: city.value,
            "onUpdate:city": _cache[2] || (_cache[2] = ($event: any) => ((city).value = $event)),
            level: 3,
            labelName: '区域',
            isOpen: _unref(getNoLoginCityCodeHome)() ? true : false,
            onChange: onChange
          }, null, 8, ["city", "isOpen"])
        ]),
        _createVNode(_component_van_dropdown_item, {
          modelValue: city.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((city).value = $event)),
          title: "区域",
          ref_key: "areaRef",
          ref: areaRef
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_dropdown_item, {
          modelValue: type.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((type).value = $event)),
          title: "类型",
          options: option2.value,
          onChange: change
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(MapMain)
    ]),
    (dialogShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_van_floating_panel, {
            height: height.value,
            "onUpdate:height": _cache[7] || (_cache[7] = ($event: any) => ((height).value = $event)),
            anchors: anchors.value,
            disableScroll: true,
            "content-draggable": contentDraggable.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['dialog_content', height.value <= 40 ? 'min_dialog_content' : 'max_dialog_content']),
                onScroll: onScroll,
                onTouchstart: ontouchstart
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(datas.value.zymc), 1),
                    _createVNode(_component_P, { class: "p_f" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_rate, {
                          modelValue: datas.value.xjNumber,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((datas.value.xjNumber) = $event)),
                          size: 14,
                          color: "#ffd21e",
                          "void-icon": "star",
                          "void-color": "#eee",
                          "allow-half": "",
                          readonly: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", _hoisted_9, [
                            _createElementVNode("span", null, _toDisplayString(datas.value.browseNum || 0), 1)
                          ])
                        ]),
                        _createElementVNode("i", _hoisted_10, _toDisplayString(datas.value.tdlx), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("span", {
                    onClick: onShare,
                    class: "share_class"
                  }),
                  _createElementVNode("div", _hoisted_11, [
                    (scShow.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                          (datas.value?.isCollect == '1')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "off_sc",
                                onClick: onClickCollect
                              }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "sc",
                                onClick: onClickCollect
                              }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                        ]))
                      : _createCommentVNode("", true),
                    (applayShow.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (userDetail.value?.accountType == 'personnel' || userDetail.value?.accountType == 'enterprise')
                            ? (_openBlock(), _createBlock(_component_van_button, {
                                key: 0,
                                color: "#ffcd01",
                                type: "primary",
                                size: "small",
                                onClick: onClickApply,
                                disabled: datas.value.isApply != '0' ? true : false
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(datas.value.isApply == "0" ? "我来运营" : "已申请"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(getTokenIn)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_van_button, {
                            color: "#ffcd01",
                            type: "primary",
                            size: "small",
                            onClick: onClickApply
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_unref(Collapse), {
                  modelValue: activeName.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeName).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CollapseItem), {
                      name: "1",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_16
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", null, [
                            _hoisted_18,
                            _createElementVNode("span", _hoisted_19, _toDisplayString(datas.value.ydqsdw || "--"), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_20,
                            _createElementVNode("span", _hoisted_21, _toDisplayString(datas.value.ydmj || 0) + " m²", 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(datas.value.ndywfy || "--"), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_24,
                            _createElementVNode("span", _hoisted_25, _toDisplayString(datas.value.jzmj || 0) + " m²", 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "2",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_26
                      ]),
                      default: _withCtx(() => [
                        (datas.value.xzzpDetail && datas.value.xzzpDetail.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createVNode(_component_van_swipe, {
                                class: "swipe-ctn",
                                autoplay: 3000,
                                "indicator-color": "#eeb230"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.xzzpDetail, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_van_swipe_item, {
                                      key: i,
                                      onClick: ($event: any) => (openImagePreview(datas.value.xzzpDetail, i))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          class: "home_img",
                                          fit: "cover",
                                          src: getImg(item.sfid),
                                          alt: ""
                                        }, null, 8, _hoisted_28)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, " 暂无照片 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "3",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_30
                      ]),
                      default: _withCtx(() => [
                        (datas.value.jycrtj)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createElementVNode("p", {
                                innerHTML: datas.value.jycrtj
                              }, null, 8, _hoisted_32)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, " 暂无经营出让条件 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "4",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_34
                      ]),
                      default: _withCtx(() => [
                        (datas.value.dkxqDetail && datas.value.dkxqDetail.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.dkxqDetail, (item, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  onClick: ($event: any) => (openImagePreview(datas.value.dkxqDetail, i))
                                }, [
                                  _createElementVNode("img", {
                                    class: "home_img",
                                    fit: "contain",
                                    src: getImg(item.sfid),
                                    alt: "",
                                    style: {"width":"100%"}
                                  }, null, 8, _hoisted_37)
                                ], 8, _hoisted_36))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, " 暂无图片 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "4",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_39
                      ]),
                      default: _withCtx(() => [
                        (datas.value.fjDetail && datas.value.fjDetail.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.fjDetail, (item, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  onClick: ($event: any) => (_unref(commons).downloadAttachment(item.sfid, item.fileName)),
                                  class: "file_name",
                                  key: i + '01'
                                }, _toDisplayString(item.fileName), 9, _hoisted_41))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_42, " 暂无附件 "))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", {
                  class: "footer_third",
                  style: _normalizeStyle({ top: setHeight() + 'px' })
                }, [
                  (scShow.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                        (datas.value?.isCollect == '1')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "off_sc",
                              onClick: onClickCollect
                            }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "sc",
                              onClick: onClickCollect
                            }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_button, {
                    color: "#ffcd01",
                    type: "primary",
                    onClick: onService
                  }, {
                    default: _withCtx(() => [
                      _hoisted_44
                    ]),
                    _: 1
                  }),
                  (applayShow.value && (userDetail.value?.accountType == 'personnel' || userDetail.value?.accountType == 'enterprise'))
                    ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 1,
                        color: "#ffcd01",
                        type: "primary",
                        onClick: onClickApply,
                        disabled: datas.value.isApply != '0' ? true : false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("span", null, _toDisplayString(datas.value.isApply == "0" ? "我来运营" : "已申请"), 1),
                            _createElementVNode("span", null, _toDisplayString(datas.value.isApply == "0" ? "(快速申请)" : ""), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (!_unref(getTokenIn)())
                    ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 2,
                        color: "#ffcd01",
                        type: "primary",
                        onClick: onClickApply
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 4)
              ], 34)
            ]),
            _: 1
          }, 8, ["height", "anchors", "content-draggable"]),
          (shareDialog.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "share_wrap",
                onClick: offShareDialog
              }, _hoisted_48))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})